import React from 'react';
import SocialCard from '../components/SocialCard'; 
import doctoralia from '../resources/doctoralia.png';
import youtube from '../resources/youtube.png';
import tiktok from '../resources/tiktok.jpeg';
import instagram from '../resources/instagram.png';
import facebook from '../resources/facebook.png';
import guia from '../resources/guia.png';
import './Redes.css';
import '../styles.css';
import CofeprisAdGallery from '../components/CofeprisAd';
import '../pages/Home.css';
const socialData = [
  {
    name: 'Facebook',
    link: 'https://www.facebook.com/GinecologoObstetraColposcopista',
    previewImage: facebook,
    username: 'GinecologoObstetraColposcopista',
  },
  {
    name: 'Instagram',
    link: 'https://www.instagram.com/ginecologo.dr.daniel.sarabia/',
    previewImage: instagram,
    username: 'ginecologo.dr.daniel.sarabia',
  },
  {
    name: 'YouTube',
    link: 'https://www.youtube.com/@drdanielsarabia4142',
    previewImage: youtube,
    username: 'drdanielsarabia4142',
  },
  {
    name: 'TikTok',
    link: 'https://www.tiktok.com/@scout2015',
    previewImage: tiktok,
    username: 'dr_daniel_sarabia',
  },
  {
    name: 'Doctoralia',
    link: 'https://www.doctoralia.com.mx/daniel-sanchez-sarabia/ginecologo/oaxaca-de-juarez',
    previewImage: doctoralia,
    username: 'Dr. Daniel Sánchez Sarabia',
  },
  {
    name: 'Guía Médica',
    link: 'http://tic-drdanielsarabia.guiamedical.com/',
    previewImage: guia,
    username: 'Guía Médica',
  },
];

const SocialSection = () => {
  return (
    
    <section className="social-section">
      <h2>Síguenos en redes sociales</h2>
        <div className="floating-buttons-container">
           <div className="floating-megafono"> <CofeprisAdGallery /></div>
          <div className="watermark-floating"></div>
      </div>

      <div className="social-grid">
        {socialData.map(({ name, link, previewImage, username }) => {
          console.log({ name, link, previewImage, username });
          return (
            <SocialCard
              key={name}
              name={name}
              link={link}
              previewImage={previewImage}
              username={username}
            />
          );
        })}
      </div>
    </section>
  );
};

export default SocialSection;
